import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { PageShell } from "../components/PageShell";
import { AppText, Button, Card, Medal } from "../components/ui";
import { Seo } from "../components/Seo";

export default function Merci() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [state, setState] = useState("checking"); // checking | paid | pending | error
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let tries = 0;
    let stop = false;
    const poll = async () => {
      tries += 1;
      try {
        const res = await api.checkoutStatus(sessionId);
        const st = res.payment_status || res.status;
        if (st === "paid" || res.status === "complete" || res.status === "paid") { setState("paid"); return; }
      } catch (e) { /* keep polling */ }
      if (stop) return;
      if (tries >= 8) { setState("pending"); return; }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { stop = true; };
  }, [sessionId]);

  return (
    <PageShell>
      <Seo title="Merci" description="Confirmation de ton paiement KM01." noindex />
      <Card className="mt-8 flex flex-col items-center text-center gap-4 py-10">
        <Medal size={96} />
        {state === "checking" && (
          <>
            <span className="h-8 w-8 animate-spin rounded-full border-4 border-km-coral border-t-transparent" />
            <AppText variant="title">On vérifie ton paiement</AppText>
          </>
        )}
        {state === "paid" && (
          <>
            <AppText variant="title">Bienvenue dans KM01 !</AppText>
            <AppText variant="body" className="text-km-ontertiary max-w-md">Ton paiement est confirmé. Tu reçois un email de bienvenue avec ton lien de connexion — pas de mot de passe à retenir.</AppText>
            <Button title="Me connecter" onClick={() => navigate("/connexion")} />
          </>
        )}
        {state === "pending" && (
          <>
            <AppText variant="title">Paiement en cours de confirmation</AppText>
            <AppText variant="body" className="text-km-ontertiary max-w-md">Ça prend parfois une minute. Tu recevras un email de bienvenue dès que c'est confirmé, avec ton lien de connexion.</AppText>
            <Button title="Me connecter" variant="secondary" onClick={() => navigate("/connexion")} />
          </>
        )}
        {state === "error" && (
          <>
            <AppText variant="title">Impossible de vérifier ce paiement</AppText>
            <AppText variant="body" className="text-km-ontertiary max-w-md">Si tu as été débité, écris-nous et on règle ça vite. Sinon, recommence depuis ton profil.</AppText>
            <Button title="Retour à l'accueil" variant="secondary" onClick={() => navigate("/")} />
          </>
        )}
      </Card>
    </PageShell>
  );
}
